import * as React from "react";
import { forwardRef } from "react";
const SvgGear = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M87.137 54.875c.2-1.6.35-3.226.35-4.875s-.134-3.276-.35-4.875L97.71 36.85a2.49 2.49 0 0 0 .6-3.2l-10-17.324a2.475 2.475 0 0 0-3.05-1.076l-12.45 5.024a38 38 0 0 0-8.449-4.924L62.49 2.1C62.255.923 61.24 0 59.99 0h-20c-1.25 0-2.276.923-2.476 2.1l-1.877 13.25a37 37 0 0 0-8.45 4.924l-12.45-5.024a2.5 2.5 0 0 0-3.049 1.076l-10 17.325c-.625 1.076-.35 2.423.6 3.2l10.55 8.274c-.2 1.6-.35 3.226-.35 4.875s.15 3.273.35 4.875L2.288 63.15c-.95.75-1.225 2.1-.6 3.2l10 17.324c.625 1.076 1.925 1.523 3.05 1.076l12.45-5.024a38 38 0 0 0 8.449 4.924l1.877 13.25c.2 1.173 1.223 2.1 2.476 2.1h20c1.25 0 2.276-.923 2.476-2.1l1.873-13.25a37 37 0 0 0 8.45-4.924l12.45 5.024a2.5 2.5 0 0 0 3.05-1.076l9.999-17.325a2.505 2.505 0 0 0-.6-3.2zm-37.15 12.624c-9.674 0-17.499-7.824-17.499-17.499s7.825-17.5 17.5-17.5 17.5 7.825 17.5 17.5-7.825 17.5-17.5 17.5" />
  </svg>
);
const ForwardRef = forwardRef(SvgGear);
export default ForwardRef;
